import './init'; // Musí být jako první!
import React from 'react';
import {render} from 'react-dom';
import {AppContainer} from 'react-hot-loader';
import 'react-redux-toastr/src/less/index.less';
import configureStore from './configureStore';
import './styles'; // Musí být jako poslední!

const store = configureStore();

function renderRoot() {
    const Root = require('./Root').default;
    const rootComponent = (
        <AppContainer>
            <Root store={store}/>
        </AppContainer>
    );
    const rootElement = document.getElementById('root');
    render(rootComponent, rootElement);
}

renderRoot();

if (module.hot) {
    module.hot.accept('./Root', renderRoot);
}
